import React from 'react';
import './bookform.css'
import pic21 from '../../assets/pic21.png'
import Inputsec6 from './inputform';
import pic22 from '../../assets/pic22.png'
import pic23 from '../../assets/pic23.png'
import { useState } from 'react';
import CTAsec6 from './cta-sec6';
import { useTranslation } from 'react-i18next';

const Bookcard = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';


    const [tickets, setTickets] = useState(1);
    const decreaseTickets = () => {
    if (tickets > 1) {
        setTickets(tickets - 1);
    }
};

const increaseTickets = () => {
    setTickets(tickets + 1);
};
    return ( 
        <form className='form1-sec6' dir={direction}>
            <h2 className='title-card-sec6'>{t('Booking Details')}</h2>

            <fieldset className='main-booking-form-cont'>
                <Inputsec6 title={t('Full Name')} title2= {t('Enter your name')}/>
                 <Inputsec6 title={t('Email Address')} title2= {t('Enter your email')}/>
                 <fieldset className='container-numb-tickets'>
                    <h2 className='title-numb-tickets'>{t('Number of Tickets')}</h2>
                    <nav className='container-row-ticket-numb'>
                        <button type="button" className='min-button'onClick={decreaseTickets}>
                            <img src={pic22} alt='pic'></img>
                        </button>
                        <button className='numb-cont'>
                            <h3 className='numb-sec6'>
                                  {i18n.language === 'ar' 
                                ? tickets.toLocaleString('ar-EG') 
                                : tickets}
                            </h3>
                        </button>
                        <button type="button" className='min-button' onClick={increaseTickets}>
                            <img src={pic23} alt='pic'></img>
                        </button>

                    </nav>
                    
                 </fieldset>
            </fieldset>

            <CTAsec6 title ={t('Confirm Booking')}/>


            <img className='circle-card-recomm' src={pic21} alt='pic'></img>
        </form>
     );
}
 
export default Bookcard;